import { ColorOptions, IconButton, LoaderNew, ModBox, SpacerNew, Text } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import { EmType } from '../../..'
import Tabbar, { TabbarType } from '../../../../../components/Tabbar'
import { useLazyApiData, useStores } from '../../../../../data/store'
import { DownloadFileComp } from '../../../CreateBulkEntities/UploadedFileDetails/DownloadFileComp'
import { ImgPDFComponent } from '../ImagePdfComponent'

interface DocumentationViewProp {
  type: string
  documentName: string
  onBackPress: () => void
  item: any
  entityId: string
  flowType?: string
  onReplacePress?: (item: any) => void
  applicationStatus?: string
}

const DocumentationView = ({
  type,
  documentName = '',
  onBackPress,
  item,
  entityId,
  flowType,
  onReplacePress,
  applicationStatus,
}: DocumentationViewProp) => {
  const { downloadKycImage, kycDocumentDownloadFetch, getDocumentTypeFromNonEditedList, isAllowedToReplace } =
    useStores((root) => ({
      downloadKycImage: root?.downloadKycImage,
      kycDocumentDownloadFetch: root?.kycDocumentDownloadFetch,
      getDocumentTypeFromNonEditedList: root?.getDocumentTypeFromNonEditedList,
      isAllowedToReplace: root.user.getAccessConfig(['aadhar_redaction', 'maker', 'isAccessible']),
      // uploadId: root?.onboarding.uploadId,
    }))
  const [imgUri, setImgUri] = useState('')
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)
  const [fetchImage, fetchImageHandler] = useLazyApiData(downloadKycImage)
  const [fetchKycDocumentDownload, kycDownloadHandler] = useLazyApiData(kycDocumentDownloadFetch)

  useEffect(() => {
    if (
      flowType === EmType.Search ||
      (flowType === EmType.applicationQueue && applicationStatus && applicationStatus === 'Completed') ||
      ((flowType === 'AD_MAKER' || flowType === 'AD_MAKER_QUEUE' || (flowType === 'AD_CHECKER' && !item?.isEdit)) &&
        entityId &&
        item)
    ) {
      fetchImage(
        entityId,
        item,
        (selectedTabIndex === 1 && item?.oldDocName?.includes('.pdf')) ||
          (selectedTabIndex === 0 && item?.NAME?.includes('.pdf'))
          ? 'PDF'
          : type,
      )
    } else if (
      (flowType === EmType.createSubGroup ||
        flowType === EmType.createGroup ||
        flowType === EmType.createSingleEntity ||
        flowType === EmType.myQueue ||
        (flowType === EmType.applicationQueue && applicationStatus && applicationStatus !== 'Completed') ||
        flowType === 'AD_MAKER' ||
        flowType === 'AD_MAKER_QUEUE' ||
        flowType === 'AD_CHECKER') &&
      item &&
      item?.RID
    ) {
      fetchKycDocumentDownload(
        item?.uploadId,
        item?.RID,
        flowType === 'AD_MAKER' || flowType === 'AD_MAKER_QUEUE' || flowType === 'AD_CHECKER' ? 'REDACT' : 'SUBGROUP', //TODO: flowType === EmType.createSubGroup ? 'SUBGROUP' : flowType === EmType.createGroup ? 'GROUP' : 'ENTITY',
        item?.NAME,
      )
    } else if (flowType === EmType.entityOnboarding) {
      fetchKycDocumentDownload(item?.uploadId, item?.RID, 'ENTITY', item?.NAME)
    }
  }, [entityId, fetchImage, fetchKycDocumentDownload, flowType, item])

  useEffect(() => {
    if (fetchImageHandler.state === 'fulfilled') {
      if (fetchImageHandler?.data !== 'failed') {
        setImgUri(fetchImageHandler?.data)
      } else {
        onBackPress()
      }
    } else if (fetchImageHandler.state === 'rejected') {
      onBackPress()
    }
  }, [fetchImageHandler?.data, fetchImageHandler.state, onBackPress, type])

  useEffect(() => {
    if (imgUri && !['PNG', 'JPG', 'PDF'].includes(type)) {
      onDownloadPress()
      onBackPress()
    }
  }, [type, imgUri])

  useEffect(() => {
    if (kycDownloadHandler?.state === 'fulfilled') {
      if (kycDownloadHandler?.data !== 'failed') {
        setImgUri(kycDownloadHandler?.data)
      } else {
        onBackPress()
      }
    } else if (kycDownloadHandler.state === 'rejected') {
      onBackPress()
    }
  }, [kycDownloadHandler?.data, kycDownloadHandler.state, onBackPress])

  const onDownloadPress = () => {
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.href = imgUri
    a.download =
      selectedTabIndex === 1 && item?.oldDocName?.length > 0 && item?.oldDocName?.includes('.pdf')
        ? item?.oldDocName
        : selectedTabIndex === 0 && item?.NAME?.length > 0 && item?.NAME?.includes('.pdf')
          ? item?.NAME
          : documentName
    a.click()
    // window.URL.revokeObjectURL(imgUri)
    document.body.removeChild(a)
  }

  const onReplaceHandle = () => {
    onReplacePress && onReplacePress(item)
  }

  const onTabSelected = (index: number) => {
    setSelectedTabIndex(index)
    if (index === 1) {
      fetchImage(
        entityId,
        item,
        (selectedTabIndex === 1 && item?.oldDocName?.includes('.pdf')) ||
          (selectedTabIndex === 0 && item?.NAME?.includes('.pdf'))
          ? 'PDF'
          : type,
      )
    } else if (index === 0) {
      fetchKycDocumentDownload(
        item?.uploadId,
        item?.RID,
        flowType === 'AD_MAKER' || flowType === 'AD_MAKER_QUEUE' || flowType === 'AD_CHECKER' ? 'REDACT' : 'SUBGROUP', //TODO: flowType === EmType.createSubGroup ? 'SUBGROUP' : flowType === EmType.createGroup ? 'GROUP' : 'ENTITY',
        item?.NAME,
      )
    }
  }

  return (
    <>
      <ModBox
        show={
          (fetchImageHandler?.state !== undefined && fetchImageHandler?.state === 'pending') ||
          (kycDownloadHandler?.state !== undefined && kycDownloadHandler?.state === 'pending')
        }
        w={'100%'}
        h={'100%'}>
        <LoaderNew color={'PRIMARY'} type={'small'} />
      </ModBox>
      <ModBox
        show={
          ((fetchImageHandler?.state !== undefined && fetchImageHandler?.state !== 'pending') ||
            (kycDownloadHandler?.state !== undefined && kycDownloadHandler?.state !== 'pending')) &&
          ['PNG', 'JPG', 'PDF'].includes(type)
        }
        alignItems={'flex-start'}
        justifyContent={'flex-start'}
        overflow={'auto'}
        w={1000}
        minHeight={700}
        h={'100%'}>
        <ModBox direction="row" w={'100%'} alignItems={'flex-start'} justifyContent={'space-between'}>
          <ModBox direction="row" w={'25%'}>
            <IconButton id="ARROW_BACK" onPress={onBackPress} size={20} color="WHITE" height={24} width={24} />
            <SpacerNew size={24} direction="horizontal" />
            <Text
              numberOfLines={6}
              title={
                selectedTabIndex === 1 && item?.oldDocName?.length > 0 && item?.oldDocName?.includes('.pdf')
                  ? item?.oldDocName
                  : selectedTabIndex === 0 && item?.NAME?.length > 0 && item?.NAME?.includes('.pdf')
                    ? item?.NAME
                    : documentName
              }
              color={'WHITE'}
              fontFamily="jiotype-bold"
              fontSize={18}
            />
          </ModBox>
          <ModBox show={flowType === 'AD_CHECKER' && item?.isEdit}>
            <Tabbar
              titles={[{ title: 'New' }, { title: 'Old' }]}
              default={selectedTabIndex}
              type={TabbarType.documentation}
              onSelected={onTabSelected}
            />
          </ModBox>
          <ModBox direction="row">
            <ModBox show={flowType === 'AD_MAKER' && isAllowedToReplace} w={98}>
              <DownloadFileComp
                type={'replace'}
                title={'Replace'}
                onButtonPress={onReplaceHandle}
                color={'WHITE'}
                alignment={'center'}
                showBorder
              />
            </ModBox>
            <ModBox marginLeft={24} w={120} show={type === 'PDF' || type === 'PNG' || type === 'JPG'}>
              <DownloadFileComp
                type={'download'}
                title={'Download File'}
                onButtonPress={onDownloadPress}
                color={'WHITE'}
                alignment={'center'}
                showBorder
              />
            </ModBox>
          </ModBox>
        </ModBox>
        <ModBox
          width={'100%'}
          minHeight={700}
          backgroundColor={'#E8E8E8' as ColorOptions}
          borderRadius={16}
          marginTop={
            (selectedTabIndex === 1 && item?.oldDocName?.includes('.pdf')) ||
            (selectedTabIndex === 0 && item?.NAME?.includes('.pdf')) ||
            type === 'PDF'
              ? 64
              : 32
          }>
          <ImgPDFComponent
            type={
              (selectedTabIndex === 1 && item?.oldDocName?.includes('.pdf')) ||
              (selectedTabIndex === 0 && item?.NAME?.includes('.pdf'))
                ? 'PDF'
                : type
            }
            imgUri={imgUri}
            onDownloadPress={onDownloadPress}
          />
        </ModBox>
      </ModBox>
    </>
  )
}

export { DocumentationView }
